// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-tile {
  width: 100%;
  padding-top: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  overflow: hidden;
  transition: background-size 0.7s ease;
}

.game-tile:hover {
  background-size: 110% 110%;
}

.game-tile:hover ion-button {
  display: block;
}

.game-tile-placeholder.ios-web-ele-touched .game-tile,
.game-tile-placeholder.not-ios-web:hover .game-tile,
.game-tile-placeholder:focus .game-tile {
  background-size: 110% 110%;
}

.information-circle-outline {
  cursor: pointer;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 99;
  position: absolute;
  font-size: 1.5rem;
}

.heart-icon {
  cursor: pointer;
  bottom: 0.5rem;
  right: 0.5rem;
  z-index: 99;
  position: absolute;
  font-size: 1.5rem;
}

.heart-outline-icon {
  cursor: pointer;
  bottom: 0.5rem;
  right: 0.5rem;
  z-index: 99;
  position: absolute;
  font-size: 1.5rem;
}

.game-tile-overlay {
  padding: 2rem;
  display: none;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.game-tile:hover .game-tile-overlay {
  display: flex;
}

jackpot-counter {
  position: absolute;
  z-index: 998;
  background: var(--ion-color-secondary);
  color: #FFFFFF;
  font-weight: bold;
  padding: 6px;
  left: 0;
  text-align: center;
  width: 100%;
  font-family: var(--font-primary);
}

.jackpot-counter-top {
  top: 0;
}

.jackpot-counter-bottom {
  bottom: 0;
}

.heart-icon-desktop {
  z-index: 1000 !important;
  bottom: 3px !important;
  right: 7px !important;
}
@media (max-width: 480px) {
  .heart-icon-desktop {
    right: 3px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/casino-lobby/game-tile/game-tile.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EAIA,qCAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;;;EAGI,0BAAA;AACJ;;AAGA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAIA;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAKA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,gCAAA;AAFJ;;AAIA;EACI,MAAA;AADJ;;AAIA;EACI,SAAA;AADJ;;AAIA;EACI,wBAAA;EACA,sBAAA;EACA,qBAAA;AADJ;AAGI;EALJ;IAMQ,qBAAA;EAAN;AACF","sourcesContent":[".game-tile {\r\n    width: 100%;\r\n    padding-top: 100%;\r\n    background-size: 100% 100%;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n    -webkit-transition: background-size 0.7s ease;\r\n    -moz-transition: background-size 0.7s ease;\r\n    -o-transition: background-size 0.7s ease;\r\n    transition: background-size 0.7s ease;\r\n}\r\n\r\n.game-tile:hover {\r\n    background-size: 110% 110%;\r\n}\r\n\r\n.game-tile:hover ion-button {\r\n    display: block;\r\n}\r\n\r\n.game-tile-placeholder.ios-web-ele-touched .game-tile,\r\n.game-tile-placeholder.not-ios-web:hover .game-tile,\r\n.game-tile-placeholder:focus .game-tile {\r\n    background-size: 110% 110%;\r\n}\r\n\r\n\r\n.information-circle-outline {\r\n    cursor: pointer;\r\n    top: 0.5rem;\r\n    right: 0.5rem;\r\n    z-index: 99;\r\n    position: absolute;\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.heart-icon {\r\n    cursor: pointer;\r\n    bottom: 0.5rem;\r\n    right: 0.5rem;\r\n    z-index: 99;\r\n    position: absolute;\r\n    font-size: 1.5rem;\r\n\r\n}\r\n\r\n.heart-outline-icon {\r\n    cursor: pointer;\r\n    bottom: 0.5rem;\r\n    right: 0.5rem;\r\n    z-index: 99;\r\n    position: absolute;\r\n    font-size: 1.5rem;\r\n\r\n}\r\n\r\n.game-tile-overlay {\r\n    padding: 2rem;\r\n    display: none;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1000;\r\n}\r\n\r\n.game-tile:hover  .game-tile-overlay {\r\n    display: flex;\r\n}\r\n\r\njackpot-counter {\r\n    position: absolute;\r\n    z-index: 998;\r\n    background: var(--ion-color-secondary);\r\n    color: #FFFFFF;\r\n    font-weight: bold;\r\n    padding: 6px;\r\n    left: 0;\r\n    text-align: center;\r\n    width: 100%;\r\n    font-family: var(--font-primary);\r\n}\r\n.jackpot-counter-top {\r\n    top: 0;\r\n}\r\n\r\n.jackpot-counter-bottom {\r\n    bottom: 0;\r\n}\r\n\r\n.heart-icon-desktop {\r\n    z-index: 1000 !important;\r\n    bottom: 3px !important;\r\n    right: 7px !important;\r\n\r\n    @media (max-width: 480px) {\r\n        right: 3px !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
